import {z} from 'zod';

export const DocumentPreviewPageValidationStatusSchema = z.enum([
  'default',
  'warning',
  'error',
  'success',
]);

export type DocumentPreviewPageValidationStatus = z.infer<
  typeof DocumentPreviewPageValidationStatusSchema
>;
